<template>
  <v-dialog v-model="show" hide-overlay persistent width="300">
    <v-card color="primary">
      <v-card-text>
        Please Wait
        <v-progress-linear indeterminate color="orange"
          class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
}
</script>

<style></style>
